import React from 'react';
import { formatCurrency, getBalanceColor } from '../../../core/utils/format';
import { ACCOUNT_TYPE_OPTIONS, STATUS } from '../../../core/constants/financial';
import { useTableSort } from '../../../core/hooks/useTableSort';
import SortableTh from './SortableTh';

const getTypeLabel = (value) =>
  ACCOUNT_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || '—';

const SORT_ACCESSORS = {
  codigo: (b) => b.code || '',
  banco: (b) => b.name || '',
  agencia: (b) => b.agency || '',
  conta: (b) => b.account || '',
  tipo: (b) => getTypeLabel(b.account_type),
  saldo: (b) => Number(b.balance) || 0,
  status: (b) => b.status || '',
};

const BankTable = ({ banks, onEdit }) => {
  const { sorted, sort, toggleSort } = useTableSort(banks, SORT_ACCESSORS);

  return (
  <div className="fd-modal-table-wrapper">
    <table className="fd-modal-table fd-modal-table--clickable">
      <thead>
        <tr>
          <SortableTh label="Código" sortKey="codigo" sort={sort} onSort={toggleSort} style={{ width: 80 }} />
          <SortableTh label="Banco" sortKey="banco" sort={sort} onSort={toggleSort} />
          <SortableTh label="Agência" sortKey="agencia" sort={sort} onSort={toggleSort} style={{ width: 110 }} />
          <SortableTh label="Conta" sortKey="conta" sort={sort} onSort={toggleSort} style={{ width: 150 }} />
          <SortableTh label="Tipo" sortKey="tipo" sort={sort} onSort={toggleSort} style={{ width: 140 }} />
          <SortableTh label="Saldo Inicial" sortKey="saldo" sort={sort} onSort={toggleSort} style={{ width: 130, textAlign: 'right' }} />
          <SortableTh label="Status" sortKey="status" sort={sort} onSort={toggleSort} style={{ width: 80, textAlign: 'center' }} />
        </tr>
      </thead>
      <tbody>
        {sorted.map((bank) => (
          <tr key={bank.id} onClick={() => onEdit(bank)} title="Clique para editar">
            <td>
              {bank.code ? <span className="fd-table-code">{bank.code}</span> : <span className="fd-table-muted">—</span>}
            </td>
            <td>
              <div style={{ fontWeight: 600 }}>{bank.name}</div>
              {bank.observation && <div style={{ fontSize: 10, marginTop: 2, color: '#777' }}>{bank.observation}</div>}
            </td>
            <td className="fd-table-muted">{bank.agency || '—'}</td>
            <td className="fd-table-muted">{bank.account || '—'}</td>
            <td>
              <span className="fd-type-tag">{getTypeLabel(bank.account_type)}</span>
            </td>
            <td style={{ textAlign: 'right', fontWeight: 700, color: getBalanceColor(bank.balance) }}>
              {formatCurrency(bank.balance)}
            </td>
            <td style={{ textAlign: 'center' }}>
              <span className={`fd-status-badge fd-status-badge--${bank.status || 'ativo'}`}>
                {bank.status === STATUS.INATIVO ? 'Inativo' : 'Ativo'}
              </span>
            </td>
          </tr>
        ))}
        {banks.length === 0 && (
          <tr>
            <td colSpan={7} className="fd-table-empty">Nenhum banco encontrado</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
  );
};

export default BankTable;
